import "core-js/modules/es.array.reduce.js";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

import { hexBuffer, intAsHexBytes, splitPath } from "../../utils";
import { destructTypeFromString, EIP712_TYPE_ENCODERS, EIP712_TYPE_PROPERTIES, makeTypeEntryStructBuffer } from "./EIP712.utils";
/**
 * @ignore for the README
 *
 * Factory to create the recursive function that will pass on each
 * field level and APDUs to describe its structure implementation
 *
 * @param {Eth["EIP712SendStructImplem"]} EIP712SendStructImplem
 * @param {EIP712MessageTypes} types
 * @returns {void}
 */

var makeRecursiveFieldStructImplem = function makeRecursiveFieldStructImplem(transport, types) {
  var _a;

  var typesMap = {};

  for (var type in types) {
    typesMap[type] = (_a = types[type]) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, curr) {
      var _a;

      return __assign(__assign({}, acc), (_a = {}, _a[curr.name] = curr.type, _a));
    }, {});
  } // This recursion will call itself to handle each level of each field
  // in order to send APDUs for each of them


  var recursiveFieldStructImplem = function recursiveFieldStructImplem(destructedType, data) {
    return __awaiter(void 0, void 0, void 0, function () {
      var _a, typeDescription, arrSizes, _b, currSize, restSizes, isCustomType, data_1, data_1_1, entry, e_1_1, _c, _d, _e, fieldName, fieldValue, fieldType, e_2_1;

      var e_1, _f, e_2, _g;

      var _h;

      return __generator(this, function (_j) {
        switch (_j.label) {
          case 0:
            _a = __read(destructedType, 2), typeDescription = _a[0], arrSizes = _a[1];
            _b = __read(arrSizes), currSize = _b[0], restSizes = _b.slice(1);
            isCustomType = !EIP712_TYPE_PROPERTIES[((_h = typeDescription === null || typeDescription === void 0 ? void 0 : typeDescription.name) === null || _h === void 0 ? void 0 : _h.toUpperCase()) || ""];
            if (!(Array.isArray(data) && typeof currSize !== "undefined")) return [3
            /*break*/
            , 10];
            return [4
            /*yield*/
            , EIP712SendStructImplem(transport, {
              structType: "array",
              value: data.length
            })];

          case 1:
            _j.sent();

            _j.label = 2;

          case 2:
            _j.trys.push([2, 7, 8, 9]);

            data_1 = __values(data), data_1_1 = data_1.next();
            _j.label = 3;

          case 3:
            if (!!data_1_1.done) return [3
            /*break*/
            , 6];
            entry = data_1_1.value;
            return [4
            /*yield*/
            , recursiveFieldStructImplem([typeDescription, restSizes], entry)];

          case 4:
            _j.sent();

            _j.label = 5;

          case 5:
            data_1_1 = data_1.next();
            return [3
            /*break*/
            , 3];

          case 6:
            return [3
            /*break*/
            , 9];

          case 7:
            e_1_1 = _j.sent();
            e_1 = {
              error: e_1_1
            };
            return [3
            /*break*/
            , 9];

          case 8:
            try {
              if (data_1_1 && !data_1_1.done && (_f = data_1["return"])) _f.call(data_1);
            } finally {
              if (e_1) throw e_1.error;
            }

            return [7
            /*endfinally*/
            ];

          case 9:
            return [3
            /*break*/
            , 21];

          case 10:
            if (!isCustomType) return [3
            /*break*/
            , 19];
            _j.label = 11;

          case 11:
            _j.trys.push([11, 16, 17, 18]);

            _c = __values(Object.entries(data)), _d = _c.next();
            _j.label = 12;

          case 12:
            if (!!_d.done) return [3
            /*break*/
            , 15];
            _e = __read(_d.value, 2), fieldName = _e[0], fieldValue = _e[1];
            fieldType = typesMap === null || typesMap === void 0 ? void 0 : typesMap[(typeDescription === null || typeDescription === void 0 ? void 0 : typeDescription.name) || ""][fieldName];
            if (!fieldType) return [3
            /*break*/
            , 14];
            return [4
            /*yield*/
            , recursiveFieldStructImplem(destructTypeFromString(fieldType), fieldValue)];

          case 13:
            _j.sent();

            _j.label = 14;

          case 14:
            _d = _c.next();
            return [3
            /*break*/
            , 12];

          case 15:
            return [3
            /*break*/
            , 18];

          case 16:
            e_2_1 = _j.sent();
            e_2 = {
              error: e_2_1
            };
            return [3
            /*break*/
            , 18];

          case 17:
            try {
              if (_d && !_d.done && (_g = _c["return"])) _g.call(_c);
            } finally {
              if (e_2) throw e_2.error;
            }

            return [7
            /*endfinally*/
            ];

          case 18:
            return [3
            /*break*/
            , 21];

          case 19:
            return [4
            /*yield*/
            , EIP712SendStructImplem(transport, {
              structType: "field",
              value: {
                data: data,
                type: (typeDescription === null || typeDescription === void 0 ? void 0 : typeDescription.name) || "",
                sizeInBits: typeDescription === null || typeDescription === void 0 ? void 0 : typeDescription.bits
              }
            })];

          case 20:
            _j.sent();

            _j.label = 21;

          case 21:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return recursiveFieldStructImplem;
};
/**
 * @ignore for the README
 *
 * This method is used to send the message definition with all its types.
 * This method should be used before the EIP712SendStructImplem one
 *
 * @param {String} structType
 * @param {String|Buffer} value
 * @returns {Promise<void>}
 */


var EIP712SendStructDef = function EIP712SendStructDef(transport, structDef) {
  var APDU_FIELDS;

  (function (APDU_FIELDS) {
    APDU_FIELDS[APDU_FIELDS["CLA"] = 224] = "CLA";
    APDU_FIELDS[APDU_FIELDS["INS"] = 26] = "INS";
    APDU_FIELDS[APDU_FIELDS["P1_complete"] = 0] = "P1_complete";
    APDU_FIELDS[APDU_FIELDS["P1_partial"] = 1] = "P1_partial";
    APDU_FIELDS[APDU_FIELDS["P2_name"] = 0] = "P2_name";
    APDU_FIELDS[APDU_FIELDS["P2_field"] = 255] = "P2_field";
  })(APDU_FIELDS || (APDU_FIELDS = {}));

  var structType = structDef.structType,
      value = structDef.value;
  var data = structType === "name" && typeof value === "string" ? Buffer.from(value, "utf-8") : value;
  return transport.send(APDU_FIELDS.CLA, APDU_FIELDS.INS, APDU_FIELDS.P1_complete, structType === "name" ? APDU_FIELDS.P2_name : APDU_FIELDS.P2_field, data);
};
/**
 * @ignore for the README
 *
 * This method provides a trusted new display name to use for the upcoming field.
 * This method should be used after the EIP712SendStructDef one.
 *
 * If the method describes an empty name (length of 0), the upcoming field will be taken
 * into account but won’t be shown on the device.
 *
 * The signature is computed on :
 * json key length || json key || display name length || display name
 *
 * signed by the following secp256k1 public key:
 * 0482bbf2f34f367b2e5bc21847b6566f21f0976b22d3388a9a5e446ac62d25cf725b62a2555b2dd464a4da0ab2f4d506820543af1d242470b1b1a969a27578f353
 *
 * @param {String} structType "root" | "array" | "field"
 * @param {string | number | StructFieldData} value
 * @returns {Promise<Buffer | void>}
 */


var EIP712SendStructImplem = function EIP712SendStructImplem(transport, structImplem) {
  return __awaiter(void 0, void 0, void 0, function () {
    var APDU_FIELDS, structType, value, rawData, type, sizeInBits, encodedData, dataLengthPer16Bits, dataLengthModulo16Bits, data_2, bufferSlices, bufferSlices_1, bufferSlices_1_1, bufferSlice, e_3_1;

    var e_3, _a;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          (function (APDU_FIELDS) {
            APDU_FIELDS[APDU_FIELDS["CLA"] = 224] = "CLA";
            APDU_FIELDS[APDU_FIELDS["INS"] = 28] = "INS";
            APDU_FIELDS[APDU_FIELDS["P1_complete"] = 0] = "P1_complete";
            APDU_FIELDS[APDU_FIELDS["P1_partial"] = 1] = "P1_partial";
            APDU_FIELDS[APDU_FIELDS["P2_root"] = 0] = "P2_root";
            APDU_FIELDS[APDU_FIELDS["P2_array"] = 15] = "P2_array";
            APDU_FIELDS[APDU_FIELDS["P2_field"] = 255] = "P2_field";
          })(APDU_FIELDS || (APDU_FIELDS = {}));

          structType = structImplem.structType, value = structImplem.value;

          if (structType === "root") {
            return [2
            /*return*/
            , transport.send(APDU_FIELDS.CLA, APDU_FIELDS.INS, APDU_FIELDS.P1_complete, APDU_FIELDS.P2_root, Buffer.from(value, "utf-8"))];
          }

          if (structType === "array") {
            return [2
            /*return*/
            , transport.send(APDU_FIELDS.CLA, APDU_FIELDS.INS, APDU_FIELDS.P1_complete, APDU_FIELDS.P2_array, Buffer.from(intAsHexBytes(value, 1), "hex"))];
          }

          if (!(structType === "field")) return [3
          /*break*/
          , 8];
          rawData = value.data, type = value.type, sizeInBits = value.sizeInBits;
          encodedData = (_b = EIP712_TYPE_ENCODERS[type.toUpperCase()]) === null || _b === void 0 ? void 0 : _b.call(EIP712_TYPE_ENCODERS, rawData, sizeInBits);
          if (!encodedData) return [3
          /*break*/
          , 8];
          dataLengthPer16Bits = Math.floor(encodedData.length / 256);
          dataLengthModulo16Bits = encodedData.length % 256;
          data_2 = Buffer.concat([Buffer.from(intAsHexBytes(dataLengthPer16Bits, 1), "hex"), Buffer.from(intAsHexBytes(dataLengthModulo16Bits, 1), "hex"), encodedData]);
          bufferSlices = new Array(Math.ceil(data_2.length / 256)).fill(null).map(function (_, i) {
            return data_2.slice(i * 255, (i + 1) * 255);
          });
          _c.label = 1;

        case 1:
          _c.trys.push([1, 6, 7, 8]);

          bufferSlices_1 = __values(bufferSlices), bufferSlices_1_1 = bufferSlices_1.next();
          _c.label = 2;

        case 2:
          if (!!bufferSlices_1_1.done) return [3
          /*break*/
          , 5];
          bufferSlice = bufferSlices_1_1.value;
          return [4
          /*yield*/
          , transport.send(APDU_FIELDS.CLA, APDU_FIELDS.INS, bufferSlice !== bufferSlices[bufferSlices.length - 1] ? APDU_FIELDS.P1_partial : APDU_FIELDS.P1_complete, APDU_FIELDS.P2_field, bufferSlice)];

        case 3:
          _c.sent();

          _c.label = 4;

        case 4:
          bufferSlices_1_1 = bufferSlices_1.next();
          return [3
          /*break*/
          , 2];

        case 5:
          return [3
          /*break*/
          , 8];

        case 6:
          e_3_1 = _c.sent();
          e_3 = {
            error: e_3_1
          };
          return [3
          /*break*/
          , 8];

        case 7:
          try {
            if (bufferSlices_1_1 && !bufferSlices_1_1.done && (_a = bufferSlices_1["return"])) _a.call(bufferSlices_1);
          } finally {
            if (e_3) throw e_3.error;
          }

          return [7
          /*endfinally*/
          ];

        case 8:
          return [2
          /*return*/
          , Promise.resolve()];
      }
    });
  });
};
/**
 * @ignore for the README
 *
 * Sign an EIP-721 formatted message following the specification here:
 * https://github.com/LedgerHQ/app-ethereum/blob/develop/doc/ethapp.asc#sign-eth-eip-712
 * @example
  eth.signEIP721Message("44'/60'/0'/0/0", {
    domain: {
      chainId: 69,
      name: "Da Domain",
      verifyingContract: "0xCcCCccccCCCCcCCCCCCcCcCccCcCCCcCcccccccC",
      version: "1"
    },
    types: {
      "EIP712Domain": [
            { name: "name", type: "string" },
            { name: "version", type: "string" },
            { name: "chainId", type: "uint256" },
            { name: "verifyingContract", type: "address" }
        ],
      "Test": [
        { name: "contents", type: "string" }
      ]
    },
    primaryType: "Test",
    message: {contents: "Hello, Bob!"},
  })
 *
 * @param {String} path derivationPath
 * @param {Object} jsonMessage message to sign
 * @param {Boolean} fullImplem use the legacy implementation
 * @returns {Promise}
 */


export var signEIP712Message = function signEIP712Message(transport, path, jsonMessage, fullImplem) {
  if (fullImplem === void 0) {
    fullImplem = false;
  }

  return __awaiter(void 0, void 0, void 0, function () {
    var APDU_FIELDS, primaryType, types, domain, message, typeEntries, typeEntries_1, typeEntries_1_1, _a, typeName, entries, entries_1, entries_1_1, _b, name_1, type, typeEntryBuffer, e_4_1, e_5_1, recursiveFieldStructImplem, domainName, domainTypeFields, domainTypeFields_1, domainTypeFields_1_1, _c, name_2, type, domainFieldValue, e_6_1, primaryTypeFields, primaryTypeFields_1, primaryTypeFields_1_1, _d, name_3, type, primaryTypeValue, e_7_1, paths, signatureBuffer;

    var e_5, _e, e_4, _f, e_6, _g, e_7, _h;

    return __generator(this, function (_j) {
      switch (_j.label) {
        case 0:
          (function (APDU_FIELDS) {
            APDU_FIELDS[APDU_FIELDS["CLA"] = 224] = "CLA";
            APDU_FIELDS[APDU_FIELDS["INS"] = 12] = "INS";
            APDU_FIELDS[APDU_FIELDS["P1"] = 0] = "P1";
            APDU_FIELDS[APDU_FIELDS["P2_v0"] = 0] = "P2_v0";
            APDU_FIELDS[APDU_FIELDS["P2_full"] = 1] = "P2_full";
          })(APDU_FIELDS || (APDU_FIELDS = {}));

          primaryType = jsonMessage.primaryType, types = jsonMessage.types, domain = jsonMessage.domain, message = jsonMessage.message;
          typeEntries = Object.entries(types);
          _j.label = 1;

        case 1:
          _j.trys.push([1, 13, 14, 15]);

          typeEntries_1 = __values(typeEntries), typeEntries_1_1 = typeEntries_1.next();
          _j.label = 2;

        case 2:
          if (!!typeEntries_1_1.done) return [3
          /*break*/
          , 12];
          _a = __read(typeEntries_1_1.value, 2), typeName = _a[0], entries = _a[1];
          return [4
          /*yield*/
          , EIP712SendStructDef(transport, {
            structType: "name",
            value: typeName
          })];

        case 3:
          _j.sent();

          _j.label = 4;

        case 4:
          _j.trys.push([4, 9, 10, 11]);

          entries_1 = (e_4 = void 0, __values(entries)), entries_1_1 = entries_1.next();
          _j.label = 5;

        case 5:
          if (!!entries_1_1.done) return [3
          /*break*/
          , 8];
          _b = entries_1_1.value, name_1 = _b.name, type = _b.type;
          typeEntryBuffer = makeTypeEntryStructBuffer({
            name: name_1,
            type: type
          });
          return [4
          /*yield*/
          , EIP712SendStructDef(transport, {
            structType: "field",
            value: typeEntryBuffer
          })];

        case 6:
          _j.sent();

          _j.label = 7;

        case 7:
          entries_1_1 = entries_1.next();
          return [3
          /*break*/
          , 5];

        case 8:
          return [3
          /*break*/
          , 11];

        case 9:
          e_4_1 = _j.sent();
          e_4 = {
            error: e_4_1
          };
          return [3
          /*break*/
          , 11];

        case 10:
          try {
            if (entries_1_1 && !entries_1_1.done && (_f = entries_1["return"])) _f.call(entries_1);
          } finally {
            if (e_4) throw e_4.error;
          }

          return [7
          /*endfinally*/
          ];

        case 11:
          typeEntries_1_1 = typeEntries_1.next();
          return [3
          /*break*/
          , 2];

        case 12:
          return [3
          /*break*/
          , 15];

        case 13:
          e_5_1 = _j.sent();
          e_5 = {
            error: e_5_1
          };
          return [3
          /*break*/
          , 15];

        case 14:
          try {
            if (typeEntries_1_1 && !typeEntries_1_1.done && (_e = typeEntries_1["return"])) _e.call(typeEntries_1);
          } finally {
            if (e_5) throw e_5.error;
          }

          return [7
          /*endfinally*/
          ];

        case 15:
          recursiveFieldStructImplem = makeRecursiveFieldStructImplem(transport, types);
          domainName = "EIP712Domain";
          return [4
          /*yield*/
          , EIP712SendStructImplem(transport, {
            structType: "root",
            value: domainName
          })];

        case 16:
          _j.sent();

          domainTypeFields = types[domainName];
          _j.label = 17;

        case 17:
          _j.trys.push([17, 22, 23, 24]);

          domainTypeFields_1 = __values(domainTypeFields), domainTypeFields_1_1 = domainTypeFields_1.next();
          _j.label = 18;

        case 18:
          if (!!domainTypeFields_1_1.done) return [3
          /*break*/
          , 21];
          _c = domainTypeFields_1_1.value, name_2 = _c.name, type = _c.type;
          domainFieldValue = domain[name_2];
          return [4
          /*yield*/
          , recursiveFieldStructImplem(destructTypeFromString(type), domainFieldValue)];

        case 19:
          _j.sent();

          _j.label = 20;

        case 20:
          domainTypeFields_1_1 = domainTypeFields_1.next();
          return [3
          /*break*/
          , 18];

        case 21:
          return [3
          /*break*/
          , 24];

        case 22:
          e_6_1 = _j.sent();
          e_6 = {
            error: e_6_1
          };
          return [3
          /*break*/
          , 24];

        case 23:
          try {
            if (domainTypeFields_1_1 && !domainTypeFields_1_1.done && (_g = domainTypeFields_1["return"])) _g.call(domainTypeFields_1);
          } finally {
            if (e_6) throw e_6.error;
          }

          return [7
          /*endfinally*/
          ];

        case 24:
          // Looping on all primaryType type entries and fields to send
          // structures' implementations
          return [4
          /*yield*/
          , EIP712SendStructImplem(transport, {
            structType: "root",
            value: primaryType
          })];

        case 25:
          // Looping on all primaryType type entries and fields to send
          // structures' implementations
          _j.sent();

          primaryTypeFields = types[primaryType];
          _j.label = 26;

        case 26:
          _j.trys.push([26, 31, 32, 33]);

          primaryTypeFields_1 = __values(primaryTypeFields), primaryTypeFields_1_1 = primaryTypeFields_1.next();
          _j.label = 27;

        case 27:
          if (!!primaryTypeFields_1_1.done) return [3
          /*break*/
          , 30];
          _d = primaryTypeFields_1_1.value, name_3 = _d.name, type = _d.type;
          primaryTypeValue = message[name_3];
          return [4
          /*yield*/
          , recursiveFieldStructImplem(destructTypeFromString(type), primaryTypeValue)];

        case 28:
          _j.sent();

          _j.label = 29;

        case 29:
          primaryTypeFields_1_1 = primaryTypeFields_1.next();
          return [3
          /*break*/
          , 27];

        case 30:
          return [3
          /*break*/
          , 33];

        case 31:
          e_7_1 = _j.sent();
          e_7 = {
            error: e_7_1
          };
          return [3
          /*break*/
          , 33];

        case 32:
          try {
            if (primaryTypeFields_1_1 && !primaryTypeFields_1_1.done && (_h = primaryTypeFields_1["return"])) _h.call(primaryTypeFields_1);
          } finally {
            if (e_7) throw e_7.error;
          }

          return [7
          /*endfinally*/
          ];

        case 33:
          paths = splitPath(path);
          signatureBuffer = Buffer.alloc(1 + paths.length * 4);
          signatureBuffer[0] = paths.length;
          paths.forEach(function (element, index) {
            signatureBuffer.writeUInt32BE(element, 1 + 4 * index);
          });
          return [2
          /*return*/
          , transport.send(APDU_FIELDS.CLA, APDU_FIELDS.INS, APDU_FIELDS.P1, fullImplem ? APDU_FIELDS.P2_v0 : APDU_FIELDS.P2_full, signatureBuffer).then(function (response) {
            var v = response[0];
            var r = response.slice(1, 1 + 32).toString("hex");
            var s = response.slice(1 + 32, 1 + 32 + 32).toString("hex");
            return {
              v: v,
              r: r,
              s: s
            };
          })];
      }
    });
  });
};
/**
 * @ignore for the README
 * Sign a prepared message following web3.eth.signTypedData specification. The host computes the domain separator and hashStruct(message)
 * @example
 eth.signEIP712HashedMessage("44'/60'/0'/0/0", Buffer.from("0101010101010101010101010101010101010101010101010101010101010101").toString("hex"), Buffer.from("0202020202020202020202020202020202020202020202020202020202020202").toString("hex")).then(result => {
 var v = result['v'] - 27;
 v = v.toString(16);
 if (v.length < 2) {
   v = "0" + v;
 }
 console.log("Signature 0x" + result['r'] + result['s'] + v);
 })
 */

export var signEIP712HashedMessage = function signEIP712HashedMessage(transport, path, domainSeparatorHex, hashStructMessageHex) {
  var domainSeparator = hexBuffer(domainSeparatorHex);
  var hashStruct = hexBuffer(hashStructMessageHex);
  var paths = splitPath(path);
  var buffer = Buffer.alloc(1 + paths.length * 4 + 32 + 32, 0);
  var offset = 0;
  buffer[0] = paths.length;
  paths.forEach(function (element, index) {
    buffer.writeUInt32BE(element, 1 + 4 * index);
  });
  offset = 1 + 4 * paths.length;
  domainSeparator.copy(buffer, offset);
  offset += 32;
  hashStruct.copy(buffer, offset);
  return transport.send(0xe0, 0x0c, 0x00, 0x00, buffer).then(function (response) {
    var v = response[0];
    var r = response.slice(1, 1 + 32).toString("hex");
    var s = response.slice(1 + 32, 1 + 32 + 32).toString("hex");
    return {
      v: v,
      r: r,
      s: s
    };
  });
};